import { TranslateService } from '@ngx-translate/core';
import { DialogObject } from '../../../../components/dialog/dialog.types';
import { BankDetailsRepository } from '../../../../store/bank-details-state/bank-details-state.repository';

interface getBankDetailsDeleteObjectProps {
  t: TranslateService;
  store?: BankDetailsRepository;
  representation?: string | number;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getBankDetailsDeleteObject = ({ t, store, representation, action, toggleVisiblity }: getBankDetailsDeleteObjectProps): DialogObject => {
  return {
    title: t.instant('settings.bankDetails.deleteConfirm', { representation: representation }),
    description: '',
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'Supprimer',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'Annuler',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
